"use client";
import { lredPacketApi, redPacketApi } from "@/api/promo";
import RedPacketModal, { RedPacketModalProps } from "@/components/ModalPopup/RedPacketModal";
import { getToken } from "@/utils/Cookies";
import React from "react";
import dialogManage from "../manager";

const isStartPacketsHandler = async () => {
    let packets = [];
    if (getToken()) {
        let redPacketInfo = await lredPacketApi();
        packets = redPacketInfo.data?.red_packets || [];
    } else {
        let redPacketInfo = await redPacketApi();
        packets = redPacketInfo.data || [];
    }
    return packets;
};

const RedPacket = () => {
    const packetModalRef = React.useRef<RedPacketModalProps>(null);
    const [data, setData] = React.useState<any>([]);

    React.useEffect(() => {
        isStartPacketsHandler().then((data) => {
            setData(data);
        });
    }, []);
    React.useEffect(() => {
        dialogManage.registerDialog({
            key: "RedPacket",
            show() {
                packetModalRef?.current?.onOpen(data);
            },
        });
    }, [data]);

    return (
        <>
            <RedPacketModal ref={packetModalRef} />
        </>
    );
};

export default RedPacket;
